<template>
  <v-container class="pa-0" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">Contactos de emergencia</span>
            <v-spacer></v-spacer>
            <v-btn color="primary" small tile @click="cargarLista">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-sheet class="mt-1 pa-3 rounded-lg" color="grey lighten-4" elevation="0">
              <v-row dense class="align-end">
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    v-model="search"
                    label="Buscar"
                    placeholder="Filtrar por cualquier dato…"
                    filled
                    dense
                    hide-details
                    clearable
                    prepend-inner-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-autocomplete
                    v-model="puestoSeleccionado"
                    :items="puestosFiltro"
                    item-text="puesto"
                    item-value="idpuesto"
                    label="Puesto"
                    filled
                    dense
                    hide-details
                    clearable
                    @change="cargarLista"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="3" class="d-flex align-end pb-1">
                  <v-btn small text color="blue-grey darken-1" @click="limpiarFiltros">
                    <v-icon left small>mdi-backspace-outline</v-icon>
                    Limpiar filtros
                  </v-btn>
                </v-col>
              </v-row>
            </v-sheet>

            <div class="text-caption grey--text text--darken-1 mt-3 mb-1">
              Total: {{ lista.length }} trabajadores de operaciones
            </div>

            <v-data-table
              :headers="headers"
              :items="lista"
              :search="search"
              :loading="cargar"
              loading-text="Cargando contactos…"
              class="elevation-0 mt-2"
              dense
              item-key="id_trabajador"
              :footer-props="{ 'items-per-page-options': [15, 30, 50, -1] }"
              :mobile-breakpoint="100"
            >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <carga v-if="cargar"></carga>
    <Alerta v-if="respuestaAlerta" :parametros="parametros"></Alerta>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import validarErrores from '@/mixins/validarErrores'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'

export default {
  name: 'ContactosEmergencia',
  components: { Alerta, carga },
  mixins: [validarErrores],
  data: function () {
    return {
      search: '',
      puestoSeleccionado: null,
      lista: [],
      puestosFiltro: [],
      headers: [
        { text: 'Trabajador', value: 'trabajador' },
        { text: 'Puesto', value: 'puesto' },
        { text: 'Contacto 1', value: 'contacto_1', sortable: false },
        { text: 'Contacto 2', value: 'contacto_2', sortable: false },
      ],
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
  },
  mounted: function () {
    this.cargarLista()
  },
  methods: {
    formatearContacto: function (item, n) {
      const nombre = (item['contacto_emergencia_' + n + '_nombre'] || '').trim()
      const parentesco = (item['contacto_emergencia_' + n + '_parentesco'] || '').trim()
      const telefono = (item['contacto_emergencia_' + n + '_telefono'] || '').trim()
      const partes = []
      if (nombre) partes.push(nombre)
      if (parentesco) partes.push(parentesco)
      if (telefono) partes.push(telefono)
      return partes.length ? partes.join(' · ') : '—'
    },
    limpiarFiltros: function () {
      this.search = ''
      this.puestoSeleccionado = null
      this.cargarLista()
    },
    armarPuestosFiltro: function (rows) {
      const map = {}
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i]
        const id = r.idpuesto || r.id_puesto
        if (!id || map[id]) continue
        map[id] = {
          idpuesto: id,
          puesto: r.puesto || 'Sin puesto',
        }
      }
      const lista = Object.keys(map).map(function (k) { return map[k] })
      lista.sort(function (a, b) {
        return String(a.puesto).localeCompare(String(b.puesto))
      })
      this.puestosFiltro = lista
    },
    cargarLista: function () {
      const self = this
      self.cargar = true
      const payload = {}
      if (self.puestoSeleccionado != null && self.puestoSeleccionado !== '') {
        payload.puesto_seleccionado = self.puestoSeleccionado
      }
      self.$http
        .post('trabajadores.erp.get.contactos.emergencia', payload)
        .then(function (response) {
          const rows = response.data || []
          for (let i = 0; i < rows.length; i++) {
            rows[i].contacto_1 = self.formatearContacto(rows[i], 1)
            rows[i].contacto_2 = self.formatearContacto(rows[i], 2)
          }
          self.lista = rows
          if (!self.puestoSeleccionado) {
            self.armarPuestosFiltro(self.lista)
          }
          self.cargar = false
        })
        .catch(function (error) {
          self.cargar = false
          let msg = 'No se pudieron cargar los contactos de emergencia'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          self.validarError(msg)
        })
    },
  },
}
</script>
